export const SET_UPLOAD_FILE_RESULTS = 'SET_UPLOAD_FILE_RESULTS';
export const SET_UPLOAD_FILE_ERROR = 'SET_UPLOAD_FILE_ERROR';

export const setUploadFileResults = (payload) =>{
  return{
    type: SET_UPLOAD_FILE_RESULTS,
    payload,
  }
}

export const setUploadFileError = (payload) =>{
  return{
    type: SET_UPLOAD_FILE_ERROR,
    payload,
  }
}
